export const CuentasPorPagarLang ={
    TituloFacturas :{
        es:'Registro de Facturas',
        en:'Invoice Registration'
    },
    TituloDetalles:{
        es:'Detalles',
        en:'Details'
    },
    tooltipNuevo: {
        es:'Nuevo Registro',
        en:'New Registration'
    },
    Page:{
        es:'Registro de Facturas',
        en:'Invoice Registration'
    },
    Proveedor:{
        es:'Proveedor',
        en:'Supplier'
    },
    Factura:{
        es:'Factura',
        en:'Invoice'
    },
    Terminos:{
        es:'Terminos',
        en:'Terms'
    },
    FechaFactura:{
        es:'Fecha Factura',
        en:'Invoice Date'
    },
    FechaIngreso:{
        es:'Fecha Ingreso',
        en:'Income Date'
    },
    Moneda:{
        es:'Moneda',
        en:'Currency'
    },
    TasaCambio:{
        es:'Tasa Cambio',
        en:'Exchange Rate'
    },
    MontoL:{
        es:'Monto L',
        en:'Amount L'
    },
    MontoD:{
        es:'Monto D',
        en:'Amount D'
    },
    CostoL:{
        es:'Costo L',
        en:'Cost L'
    },
    CostoD:{
        es:'CostoD',
        en:'Costo D'
    },
    TipoFactura:{
        es:'Tipo Factura',
        en:'Invoice Type'
    },
    Comentario:{
        es:'Comentario',
        en:'Comment'
    },
    FechaVencimiento:{
        es:'Fecha Vencimiento',
        en:'Expired Date'
    },
    Herramientas:{
        es:'Herramientas',
        en:'Tools'
    },
    BtnNuevaFila:{
        es:'NuevaFila',
        en:'New Row'
    },
    BtnRemoveroFila:{
        es:'Remover Filas',
        en:'Remove Rows'
    },
    BtnGuardar:{
        es:'Guardar',
        en:'Save'
    },
    BtnRecargar:{
        es:'Recargar',
        en:'Refresh'
    },
    BtnEditar:{
        es:'Editar',
        en:'Edit'
    },
    BtnProveedoresCAI:{
        es:'CAIS Proveedor',
        en:'Supplier CAIS'
    },
    BtnEliminarRegistro:{
        es:'Eliminar Registro',
        en:'Deleted Register'
    },
    EstadoFinanzas:{
        es:'Estado Finanzas',
        en:'Finance Status'
    },
    Ingreso:{
        es:'Ingreso',
        en:'User entry'
    },
    Edicion:{
        es:'Edición',
        en:'Edition'
    },
    MensajeError:{
        es:'Debe Completar todos los campos',
        en:'You must complete all fields.'
    },
    ProveedorCAI:{
        es:'CAI Proveedor',
        en:'Supplier CAI'
    },
    NuevoRegistro:{
        es:'Nuevo Registro',
        en:'Register New'
    },
    FechaRecibidoCompras: {
        es:'Fecha Recibido Compras',
        en:'Received by Purchasing Date'
    },
    FechaRecibidoFinanzas:{
        es:'Fecha Recibido Finanzas',
        en:'Received by Finance Date'
    },
    TituloMateriaPrima:{
        en:'Raw Material Invoice Register',
        es:'Registro Facturas Materia Prima'
    },








}